{
  "env_name": "local",
  "GT_DSN_INTERVIEWER_PORTAL": "https://9b4f3209f2cc44e6b097861960722d75@gt-analytics.infersurveys.com/3"
}
